export const LOGIN_REWARD = { propId: 70100004, propName: '点券', count: 1000 }
export const LOTTERY_WHEEL_LIST = [
  { id: 1, sort: 1, propId: 70100101, propName: '金钻', count: 1000 },
  { id: 2, sort: 2, propId: 70100101, propName: '金钻', count: 200 },
  { id: 3, sort: 7, propId: 80102101, propName: '金钻抵用券', count: 10 },
  { id: 4, sort: 4, propId: 80102101, propName: '金钻抵用券', count: 2 },
  { id: 5, sort: 8, propId: 80202003, propName: '枪械三级升级卡', count: 50 },
  { id: 6, sort: 6, propId: 80202003, propName: '枪械三级升级卡', count: 10 },
  { id: 7, sort: 7, propId: 70100004, propName: '点券', count: 5000 },
  { id: 8, sort: 8, propId: 70100004, propName: '点券', count: 2000 },
  { id: 9, sort: 2, propId: 70100004, propName: '点券', count: 1000 },
  { id: 10, sort: 10, propId: 70100004, propName: '点券', count: 1000 },
]

export const REWARDS_LIST = [
  { id: 1, lotteryTimes: 3, rewarded: 1, props: [ // 金钻*100
    { id: 70100101, name: '金钻', count: 100 }
  ] },
  { id: 2, lotteryTimes: 5, rewarded: 0, props: [ // 金钻*250、枪械三级升级卡*3
    { id: 70100101, name: '金钻', count: 250 },
    { id: 80202003, name: '枪械三级升级卡', count: 3 }
  ] },
  { id: 3, lotteryTimes: 10, rewarded: 0, props: [ // 金钻*500、金钻抵用券*3、枪械三级升级卡*3
    { id: 70100101, name: '金钻', count: 500 },
    { id: 80102101, name: '金钻抵用券', count: 3 },
    { id: 80202003, name: '枪械三级升级卡', count: 3 }
  ] },
  { id: 4, lotteryTimes: 20, rewarded: 0, props: [ // 金钻*1000、金钻抵用券*6、枪械三级升级卡*6
    { id: 70100101, name: '金钻', count: 1000 },
    { id: 80102101, name: '金钻抵用券', count: 6 },
    { id: 80202003, name: '枪械三级升级卡', count: 6 }
  ] },
  { id: 5, lotteryTimes: 30, rewarded: 0, props: [ // 金钻*2250、金钻抵用券*9、枪械三级升级卡*9
    { id: 70100101, name: '金钻', count: 2250 },
    { id: 80102101, name: '金钻抵用券', count: 9 },
    { id: 80202003, name: '枪械三级升级卡', count: 9 }
  ] },
  { id: 6, lotteryTimes: 50, rewarded: 0, props: [ // 金钻*3750、金钻抵用券*15、枪械三级升级卡*15、点券*5000
    { id: 70100101, name: '金钻', count: 3000 },
    { id: 80102101, name: '金钻抵用券', count: 15 },
    { id: 80202003, name: '枪械三级升级卡', count: 15 },
    { id: 70100004, name: '点券', count: 5000 }
  ] },
]